import React, { useState } from "react";
import { Table, Tag, Button, Dropdown } from "antd";
import { ArrowUpRight, MoreHorizontal, UserRoundX } from "lucide-react";

const getStatusClass = (status) => {
  switch (status) {
    case "ACTIVE":
      return "text-green-700";
    case "IN_PROGRESS":
      return "text-yellow-700";
    case "COMPLETED":
      return "text-blue-700";
    default:
      return "text-gray-700";
  }
};

const InterviewStudentsTable = ({
  studentsData,
  setSelectedUserIds,
  selectedUserIds,
  setUnAssignStudentFlag,
}) => {
  const rowSelection = {
    selectedRowKeys: selectedUserIds,

    onChange: (selectedRowKeys) => {
      setSelectedUserIds(selectedRowKeys);
    },
  };

  const actionItems = [
    {
      key: "unassign",
      label: (
        <span className="text-gray-700 font-medium text-[.8rem] flex gap-[6px] items-center">
          {" "}
          <UserRoundX size={15} />
          Unassign Guide
        </span>
      ),
    },
  ];

  const columns = [
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">Name</span>
      ),
      dataIndex: "firstName",
      key: "name",
      // width: 120, // Increased width for Name column
      render: (_, record) => {
        const studentUserId = record?.userIdentifier || record?.userId;
        const menuItems = [
          {
            key: "unassign-mock-interview",
            label: (
              <span className="flex items-center gap-2 font-medium text-[.82rem] text-[#344054] hover:text-[#DC6803]">
                <UserRoundX size={15} className="text-[#DC6803]" />
                <span>Unassign Mock Interview</span>
              </span>
            ),
          },
        ];

        const handleMenuClick = ({ key }) => {
          if (key === "unassign-mock-interview") {
            setSelectedUserIds([studentUserId]);
            setUnAssignStudentFlag(true);
          }
        };

        return (
          <Dropdown
            menu={{
              items: menuItems,
              onClick: handleMenuClick,
            }}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div className="group cursor-pointer inline-flex flex-col py-1 px-2 -mx-2 rounded-md transition-all duration-200 hover:bg-[#FFFAEB]/80 border border-transparent hover:border-[#FEDF89]">
              <p className="font-semibold text-gray-800 mb-0 text-[.8rem] transition-colors duration-200 group-hover:text-[#DC6803]">
                {record?.firstName} {record?.lastName}
              </p>
              <p className="text-[.75rem] text-[#475467] font-normal transition-colors duration-200 group-hover:text-[#B54708]">
                {studentUserId || "N/A"}
              </p>
            </div>
          </Dropdown>
        );
      },
    },
    {
      title: (
        <div className="text-[#475467] font-medium text-[.8rem]">
          Batch name
        </div>
      ),
      dataIndex: "prepGuidesAssigned",
      key: "prepGuidesAssigned",
      // width: 40, // Reduced width
      render: (_, record) => (
        <span className="font-normal text-[#475467] text-[.8rem]">
          {record?.batchName ?? "N/A"}
        </span>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">
          Student Id & Email
        </span>
      ),
      // dataIndex: "batchName",
      key: "email",
      // width: 60,
      render: (record) => (
        <div>
          <p className="text-[.8rem] text-[#475467] font-normal">
            {record?.studentId || "N/A"}
          </p>
          <p className="text-[#475467] font-normal text-[.8rem]">
            {record?.emailId || "N/A"}
          </p>
        </div>
      ),
    },
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Assigned date{" "}
        </div>
      ),
      dataIndex: "creationDate",
      key: "creationDate",
      align: "center",
      // width: 40,
      render: (_, record) => (
        <span className="text-[#475467] font-normal text-[.8rem]">
          {new Date(record?.assignedDate).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </span>
      ),
    },
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Interview score
        </div>
      ),
      dataIndex: "score",
      key: "score",
      align: "center",
      // width: 40, // Reduced width
      render: (_, record) => (
        <span className="font-normal text-[#475467] text-[.8rem]">
          {record?.interviewScore ?? "N/A"}
        </span>
      ),
    },
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Interview state
        </div>
      ),
      // dataIndex: "score",
      // key: "score",
      align: "center",
      // width: 40, // Reduced width
      render: (_, record) => (
        <span className="font-normal text-[#475467] text-[.8rem]">
          {record?.interviewState
            ?.toLowerCase()
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ") ?? "N/A"}
        </span>
      ),
    },
    /*
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Action
        </div>
      ),
      key: "action",
      align: "center",
      // width: 40,
      render: (_, record) => (
        // <Dropdown
        //   menu={{
        //     items: actionItems,
        //     onClick: ({ key }) => {
        //       if (key === "unassign") {
        //         setSelectedUserIds([record?.userId]);
        //         setUnAssignStudentFlag(true);
        //       }
        //     },
        //   }}
        //   trigger={["click"]}
        //   placement="bottomRight"
        // >
        <Button
          type="text"
          icon={<MoreHorizontal size={16} />}
          className="!text-gray-500 !p-0 !w-6 !h-6"
        />
        // </Dropdown>
      ),
    }, */
  ];

  return (
    <div className="rounded-2xl bg-white shadow-sm">
      <Table
        columns={columns}
        dataSource={studentsData}
        // rowKey="batchName"
        rowKey="userIdentifier"
        pagination={false}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        scroll={{ x: 1100 }}
      />
    </div>
  );
};

export default InterviewStudentsTable;
